export default "__VITE_ASSET__DN5nhs63__"